/**
 * How the chat behaves on this deployment, from `/meta/capabilities`.
 *
 * `mode` is the backend's `ASSISTANT_MODE`: `intake` (the go-live default — no
 * troubleshooting, get the issue raised quickly) or `assist` (general IT
 * guidance as well). It only changes copy here; the behaviour is the server's.
 *
 * `available` is `false` when the server is running its scripted stand-in
 * rather than the real model, and `null` while that is not known yet (still
 * loading, failed, or an older server that does not report it). Only a
 * definite `false` changes the page, so nothing flashes while it loads.
 */

import { useCapabilities } from "@/lib/api";

export type AssistantModeName = "intake" | "assist";

export interface AssistantCapabilityState {
  mode: AssistantModeName;
  available: boolean | null;
}

export function useAssistantCapability(): AssistantCapabilityState {
  const { data } = useCapabilities();
  const assistant = data?.assistant ?? null;
  return {
    mode: assistant?.mode ?? "intake",
    available: assistant === null ? null : assistant.available,
  };
}
